export const pt = {
  returnRequestDate: {
    label: "O seu pedido de devolução foi feito em {{date}} às {{time}}",
  },
  actions: {
    continue: "Continuar",
  },
  "order-identification": {
    title: "Acompanhe o seu pedido",
    description:
      "Insira os detalhes do seu pedido para rastrear a sua encomenda",
    fields: {
      "zip-code": {
        title: "Código postal",
        description: "Insira o seu código postal de entrega",
        required: "O código postal é obrigatório",
      },
      "tracking-number": {
        title: "Número do pedido",
        description: "Insira o número do seu pedido",
        required: "O número do pedido é obrigatório",
      },
    },
    errors: {
      "unknown-order": {
        title: "Número de pedido desconhecido",
        description:
          "O número do pedido não foi encontrado, por favor verifique-o",
      },
      "search-error": {
        title: "Erro de pesquisa",
        description:
          "Não conseguimos encontrar o pedido. Por favor, tente novamente mais tarde.",
      },
    },
  },
  delivery: "Entrega",
  "parcel-history": "Histórico da encomenda",
  "order-details": {
    title: "Detalhes do pedido",
    "tracking-number": "Número de rastreamento",
    "order-number": "Número do pedido",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Data estimada de entrega",
      deliveredOn: "Entregue em",
      from: "de",
      to: "a",
    },
  },
  deliveryAddress: {
    title: "Endereço de entrega:",
    titlePickup: "Endereço do ponto de recolha:",
    orderDetails: {
      title: "Detalhes do pedido:",
      trackingNumber: "Número de rastreamento:",
      orderNumber: "Número do pedido:",
      orderDate: "Data do pedido:",
    },
  },
  pickupPoint: {
    title: "Ponto de recolha",
    openingHours: "Horário de funcionamento:",
    closed: "Fechado",
    directions: "Direções",
    days: {
      monday: "Segunda-feira:",
      tuesday: "Terça-feira:",
      wednesday: "Quarta-feira:",
      thursday: "Quinta-feira:",
      friday: "Sexta-feira:",
      saturday: "Sábado:",
      sunday: "Domingo:",
    },
  },
  wallet: {
    warningNotEnabled:
      "Você deve ativar a Wallet nas configurações da sua loja",
  },
  crossSell: {
    youMightAlsoLike: "Você também pode gostar",
  },
  "rate-order": {
    "order-recap": {
      title: "O seu pedido",
      "tracking-label": "Número de rastreamento:",
      "order-label": "Número do pedido:",
    },
    form: {
      title: "Avalie a sua entrega",
      "rating-label": "Avalie a sua experiência de entrega",
      "comment-label": "Comentário (opcional)",
      "comment-placeholder": "Partilhe connosco a sua experiência…",
      "submit-cta": "Enviar a minha avaliação",
      "update-cta": "Atualizar a minha avaliação",
      "rating-required": "Por favor, selecione uma avaliação.",
    },
    "thank-you": {
      title: "Obrigado pelo seu feedback!",
      description:
        "A sua avaliação foi guardada. Vai ajudar-nos a melhorar a experiência de entrega.",
    },
    errors: {
      "invalid-token": {
        title: "Link inválido ou expirado",
        description:
          "Este link já não é válido. Por favor, abra-o novamente a partir do seu último email de rastreamento.",
      },
      submit: {
        title: "Algo correu mal",
        description:
          "Não conseguimos guardar a sua avaliação. Por favor, tente novamente mais tarde.",
      },
    },
  },
} as const;
